import { PortableTextTypeComponent } from '@portabletext/react'

import { CarbonVariant } from 'src/components/molecules/CalculatorSectionRebrand'
import { CarbonActivities } from 'src/components/molecules/CarbonActivities'

import { BodyElement, ElementOf } from '../types'

export const CO2WidgetBlock: PortableTextTypeComponent<BodyElement> = ({
  value
}) => {
  const { showExamples } = value as ElementOf<'co2Widget'>

  return (
    <>
      <CarbonVariant />
      {showExamples && (
        <div className='mt-10'>
          <CarbonActivities />
        </div>
      )}
    </>
  )
}
